import IconButton from '@mui/material/IconButton';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useKioskManager } from '../../../hooks/useKioskManager';
import { useLetsGo } from '../../../hooks/useLetsGo';
import ButtonStyled from '../button/Button';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import TextButton from '../textButton/TextButton';
import type { SideProps } from '../types';
import styles from './locationDetailCard.module.scss';

type LocationDetailCardProps = SideProps & {
  handleClose: () => void;
  handleShowDetails: () => void;
  isOpen: boolean;
  image: string;
  title: string;
  id: number;
};

const LocationDetailCard = forwardRef<HTMLDivElement, LocationDetailCardProps>(
  ({ handleClose, handleShowDetails, isOpen, image, title = '', id }, ref) => {
    const { t } = useTranslation('common');
    const handleLetsGo = useLetsGo(id);
    const { kiosk, kioskMode } = useKioskManager();

    return isOpen ? (
      <div
        className={`
        ${styles.card}
        ${kiosk && kioskMode && styles[kiosk.model]}
      `}
        id={`popup-${id}`}
        ref={ref}
      >
        <div className={styles.header}>
          <IconButton className={styles.btnClose} onClick={handleClose}>
            <Icon
              icon={IconType.CLOSE}
              size="full"
              color="#000"
              ariaLabel="Close"
              ariaRole="button"
            />
          </IconButton>
        </div>
        <img src={image} alt={title} className={styles.image} />
        <div className={styles.content}>
          <h1 className={styles.contentTitle}>{title}</h1>
          <TextButton
            label={t('labels.viewLocationDetails')}
            onClick={handleShowDetails}
            side="right"
            capitalize
            underline
          />
          <ButtonStyled onClick={handleLetsGo} className={styles.btnSubmit}>
            {t('labels.letsGo')}
          </ButtonStyled>
        </div>
      </div>
    ) : (
      <></>
    );
  },
);

export default LocationDetailCard;
